import styled from '@emotion/styled';
import css from '@emotion/css';
import theme from 'utils/theme';
import media from 'utils/media';

export const IconImg = styled.img`
  position: absolute;
  width: 16px;
  height: 16px;
  top: 10px;

  &:nth-of-type(2) {
    right: 0;
  }
`;

export const SelectMenu = styled.ul`
  position: absolute;
  box-shadow: rgb(0 0 0 / 10%) 0 10px 10px;
  border: 1px solid ${theme.colors.lightGray_6};
  width: 100%;
  background: white;
  top: 45px;
  max-height: 230px;
  overflow-y: auto;
  z-index: 10;
`;

export const SelectMenuItem = styled.li`
  width: 100%;

  button {
    display: flex;
    justify-content: space-between;
    padding: 13px 18px;
    font-size: 18px;
    font-weight: normal;
    width: 100%;
    text-align: left;

    &:hover {
      background-color: ${theme.colors.lightGray_6};
    }
  }
`;

export const SelectSubtitle = styled.span`
  color: ${theme.colors.darkGray_9};

  ${media.greaterThan.md} {
    margin-top: 0;
    font-size: 0.94em;
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 45px;
  height: 80px;
  width: 100%;
  background: #fff;
  border: 1px solid ${theme.colors.lightGray_6};
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);
  z-index: 2;

  div {
    top: 35px;
  }
`;

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
`;

export const StyledCheckboxWrapper = styled.label`
  position: relative;
  display: flex;
  padding-bottom: 25px;
  margin-bottom: 5px;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 4px;
  width: 16px;
  height: 16px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenCheckbox = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + .styled-checkbox {
    background: black;

    ${Icon} {
      visibility: visible;
    }
  }
`;

export const StyledCheckboxIcon = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  background: white;
  border: 1px solid #000;
  border-radius: 2px;
  transition: all 150ms;

  ${Icon} {
    visibility: hidden;
  }
`;

export const StyledCheckboxLabel = styled.span`
  padding-top: 1px;
`;

export const Error = styled.span`
  position: absolute;
  display: block;
  color: ${theme.colors.error};
  width: 100%;
  text-align: right;

  ${({ isTextarea }) => (isTextarea ? `top: 106px;` : `top: 45px;`)}
`;

export const StyledLabelContainer = styled.div`
  width: 100%;

  ${Error} {
    position: relative;
    top: 5px;
  }
`;

const labelStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 16px;
  margin-bottom: 10px;
`;

export const StyledLabel = styled.label`
  ${labelStyles}
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
  color: #4f4f4f;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid;

  ::placeholder {
    color: #4f4f4f;
    opacity: 1;
  }

  ${props =>
    props.isError &&
    `
		border-color: ${theme.colors.error};
	`}
`;

export const StyledPhoneInputLabel = styled.label`
  ${labelStyles}

  .input-error.react-tel-input > .form-control {
    border-color: ${theme.colors.error};
  }

  .react-tel-input .form-control {
    width: 100%;
    height: 40px;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    color: #4f4f4f;
    border: 0;
    border-bottom: 1px solid;
    border-radius: 0;
    font-family: ${theme.fonts.body};
  }
  .react-tel-input .form-control.invalid-number {
    border: none;
    background-color: transparent;
    border-bottom: 1px solid;
    border-color: ${theme.colors.error};
  }
  .react-tel-input .flag-dropdown,
  .react-tel-input .flag-dropdown.invalid-number {
    border: none;
    background-color: transparent;
  }
  .react-tel-input .selected-flag:hover,
  .react-tel-input .selected-flag:focus {
    background-color: transparent;
  }
  .react-tel-input .flag {
    transform: scale(1.5);
  }

  .react-tel-input .country-list .search {
    z-index: 1;
  }

  ${media.greaterThan.md} {
    .form-control {
      font-size: 20px;
      line-height: 20px;
    }
  }

  ${props => !props.stylesLoaded && `visibility: hidden;`}
`;

export const StyledTextarea = styled.textarea`
  height: 102px;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #4f4f4f;
  border: 1px solid;
  padding: 7px 10px;
`;
